import { useRef } from 'react';
import { isSafeUrl } from '@atlaskit/linking-common/url';
export function useSearchQuery(state) {
  var _queryState$current;
  var queryState = useRef(null);

  /*
   * When state contains a valid url AND is NOT selected from results, and the url was updated
   * from the textbox, queryState should be null to clear the items in plugin state.
   *
   * Checking `lastEditedBy` prevents the items being cleared when the tab is changed.
   */
  if (isSafeUrl(state.url) && state.selectedIndex === -1 && !state.preventHidingRecents) {
    queryState.current = null;
  }

  /*
   * When state contains a search term e.g. Not a valid url return a query
   */
  if (((_queryState$current = queryState.current) === null || _queryState$current === void 0 ? void 0 : _queryState$current.query) !== state.url && !isSafeUrl(state.url)) {
    queryState.current = {
      query: state.url
    };
  }

  /*
   * When state contains a valid url and is selected from the list
   * return current state to prevent triger a new plugin search
   */
  return queryState.current;
}